/**
 * open-target-lib.ts — Phần THUẦN của nguyên tắc điều hướng module Nhân viên AI (góp ý chủ sản phẩm):
 *   "Thao tác cần đi sang MÀN KHÁC thì mở TAB MỚI; màn hiện tại giữ nguyên và thẻ bị ảnh hưởng có nút Tải lại."
 *
 * Điều hướng NỘI BỘ của luồng đang làm vẫn cùng tab:
 *   - `hub`    (Bắt đầu, danh sách nhân viên AI): sang luồng tạo mới, mở màn một nhân viên AI, về danh sách / Bắt đầu.
 *   - `wizard` (luồng tạo 5 bước): chuyển bước (`/ai/nhan-vien/moi?…`).
 *   - `staff`  (màn một nhân viên AI): chuyển mục qua hash (`/ai/nhan-vien/<id>#…`).
 * Mọi đường dẫn khác (Kho tri thức, Kết nối, Nguồn AI và lượt AI, Thư mục dùng chung, Theo dõi, Hộp thư, trang Phân tích, màn nhân
 * viên AI KHÁC…) → tab mới.
 */
import { AI_PATHS } from '@/lib/ai-khung'

/** Màn Kết nối kênh chat (Zalo, Facebook, TikTok…). */
export const CONNECT_CHANNELS_PATH = '/integrations'
/** Màn Kết nối ứng dụng (Evotech, Google Sheet…) — nguồn sản phẩm / đơn hàng cho AI. */
export const CONNECT_APPS_PATH = '/integrations/apps'
/** Màn Sản phẩm (nhập tay / nhập file). */
export const PRODUCTS_PATH = '/ai/san-pham'

export type LinkContext =
  | { screen: 'hub' }
  | { screen: 'wizard' }
  | { screen: 'staff'; botId: string }

/** Phần đường dẫn (bỏ `?query`, `#hash`, dấu `/` cuối). */
export function pathnameOf(path: string): string {
  const p = path.split(/[?#]/)[0] || '/'
  return p.length > 1 ? p.replace(/\/+$/, '') : p
}

const isAbsoluteUrl = (path: string) => /^[a-z][a-z0-9+.-]*:\/\//i.test(path) || path.startsWith('//')

const isWizard = (p: string) => p === AI_PATHS.newBot
/** `/ai/nhan-vien/<id>` (đúng một cấp, không phải luồng tạo, không phải `/phan-tich`). */
const isStaffDetail = (p: string) => p.startsWith(`${AI_PATHS.bots}/`) && !isWizard(p) && !p.slice(AI_PATHS.bots.length + 1).includes('/')

/** Đường dẫn này có phải màn KHÁC (→ mở tab mới) khi đang đứng ở `ctx` không. */
export function opensInNewTab(path: string, ctx: LinkContext): boolean {
  if (!path || isAbsoluteUrl(path)) return true
  const p = pathnameOf(path)
  switch (ctx.screen) {
    case 'hub':
      return !(p === AI_PATHS.bots || p === AI_PATHS.start || isWizard(p) || isStaffDetail(p))
    case 'wizard':
      return !isWizard(p)
    case 'staff':
      // Trang Phân tích là màn con của chính nhân viên này → cùng tab (có nút Quay lại).
      return p !== `${AI_PATHS.bots}/${ctx.botId}` && p !== `${AI_PATHS.bots}/${ctx.botId}/phan-tich`
  }
}

/**
 * Kết quả của một lần "Tải lại" có lỗi không: hàm ném lỗi được xử lý ở nơi gọi; ở đây bắt thêm kết quả `refetch()` của
 * TanStack Query (không ném mà trả `{ isError: true }`), kể cả lồng trong mảng (`Promise.all([q1.refetch(), q2.refetch()])`).
 */
export function reloadFailed(results: unknown[]): boolean {
  return results.some((r) => (Array.isArray(r) ? reloadFailed(r) : !!r && typeof r === 'object' && (r as { isError?: unknown }).isError === true))
}
